import { LayoutComponent } from './layout/layout/layout.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SettingsComponent } from './components/settings/settings.component';
import { DashboardComponent } from './components/dashboard-documente/dashboard.component';
import { BorderouComponent } from './components/borderou/borderou.component';
import { AdminSetariComponent } from './platform/nomenclatoare/administrativ/admin-setari/admin-setari.component';
import { TokenComponent } from './components/token/token.component';
import { TokenGuard } from './guards/token.guard';
import { PermissionsGuard } from './guards/permissions.guard';
import { SabloaneComponent } from './components/sabloane/sabloane.component';
import { EntitatiComponent } from './components/entitati/entitati.component';
import { InboxComponent } from './components/inbox/inbox.component';
import { SlugPageComponent } from './components/slugPage/slug-page.component';
import { DecedatiComponent } from './components/decedati/decedati.component';
import { VerificareEvidentaComponent } from './components/verificare-evidenta/verificare-evidenta.component';
import { RapoarteComponent } from './components/rapoarte/rapoarte.component';
import { RegistruComponent } from './components/registru/registru.component';
import { NotificariComponent } from './components/notificari/notificari.component';
import { RapoarteActivitateComponent } from './components/rapoarte-activitate/rapoarte-activitate.component';
import { RaportActivitateDetaliatComponent } from './components/raport-activitate-detaliat/raport-activitate-detaliat.component';
import { AwbComponent } from './components/awb/awb.component';
import { OperatorSigningLogsComponent } from './components/operator-signing-logs/operator-signing-logs.component';
import { AuditLogsComponent } from './components/audit-logs/audit-logs.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: '/documente',
        pathMatch: 'full',
    },
    {
        path: '',
        component: LayoutComponent,
        canActivate: [TokenGuard, PermissionsGuard],
        children: [
            {
                path: 'documente',
                component: DashboardComponent,
            },
            {
                path: 'settings',
                component: SettingsComponent,
            },
            {
                path: 'inbox',
                component: InboxComponent,
            },
            {
                path: 'notificari-email',
                component: NotificariComponent,
            },
            {
                path: 'sabloane',
                component: SabloaneComponent,
            },
            {
                path: 'borderou',
                component: BorderouComponent,
            },
            {
                path: 'admin-settings',
                component: AdminSetariComponent,
            },
            {
                path: 'entitati',
                component: EntitatiComponent,
            },
            {
                path: 'verificare-evidenta',
                component: VerificareEvidentaComponent,
            },
            {
                path: 'decedati',
                component: DecedatiComponent,
            },
            {
                path: 'raport',
                component: RapoarteComponent,
            },
            {
                path: 'registru',
                component: RegistruComponent,
            },
            {
                path: 'awb',
                component: AwbComponent,
            },
            {
                path: 'raport-activitate',
                component: RapoarteActivitateComponent,
            },
            {
                path: 'raport-activitate-detaliat',
                component: RaportActivitateDetaliatComponent,
            },
            {
                path: 'operator-signing-logs',
                component: OperatorSigningLogsComponent,
            },
            {
                path: 'audit-logs',
                component: AuditLogsComponent,
            },
            {
                path: 'user-profile',
                loadChildren: () => import('./components/user-profile/user-profile.module').then(m => m.UserProfileModule)
            },
            { path: ':slug', component: SlugPageComponent },
        ],
    },
    {
        path: 'token/:token',
        component: TokenComponent,
    },
    {
        path: '**',
        redirectTo: '/documente',
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            scrollPositionRestoration: 'enabled',
            anchorScrolling: 'enabled',
            useHash: true,
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule { }
